import { FinancingRole, FinancingUser, OrganizationsResult } from '@indigo-ag/schema';
import { Tab, Tabs } from '@material-ui/core';
import i18next from 'core/i18n';
import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { Link, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';

import { NewPage } from 'core/components';
import { rolesAndUsers } from 'features/admin/adminQueries';
import { LoadingWrapper, createStylesHook } from 'shared';
import { AddNewUser } from '../components/AddNewUser/AddNewUser';
import { UserList } from '../components/UserList/UserList';

const useStyles = createStylesHook({
  styleTabs: {
    background: '#FFFFFF',
    boxShadow: '0px 2px 4px rgba(0, 87, 125, 0.14), 0px 2px 2px rgba(0, 87, 125, 0.1)',
    borderTopLeftRadius: '6px',
    borderTopRightRadius: '6px',
    marginBottom: '0.04rem',
    paddingTop: '6px',
    '& + div': {
      borderTopLeftRadius: '0px !important',
      borderTopRightRadius: '0px !important'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#1D4F6D',
      height: '4px'
    },
    '& .MuiTab-root': {
      color: '#00577D',
      fontSize: '1rem',
      'font-weight': '500',
      opacity: 1
    },
    '& .Mui-selected': {
      color: ' #303C41'
    }
  }
});
export const UserManagementPage: React.FunctionComponent = () => {
  const [activeTabId, setActiveTab] = useState(0);

  /**
   * Styles
   */
  const classes = useStyles();
  /**
   * History
   */
  const history = useHistory();

  /**
   * Routes Matching
   */
  const match = useRouteMatch();
  const handleTabChange = (_: any, tab: any) => setActiveTab(tab);
  const tabsConfig = [
    {
      label: i18next.t('users'),
      path: '/users'
    }
  ];
  useEffect(() => {
    const index = tabsConfig.findIndex(tab => new RegExp(match.url + tab.path, 'i').test(history.location.pathname));
    if (index >= 0) {
      setActiveTab(index);
    }
  }, [history.location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LoadingWrapper query={rolesAndUsers}>
      {({
        data
      }: {
        data: {
          allAssignableFinancingRoles: FinancingRole[];
          financingUsers: FinancingUser[];
          financingCurrentUser: Pick<FinancingUser, 'email'>;
          financingOrganizations: OrganizationsResult;
        };
      }) => {
        const myEmail = data.financingCurrentUser.email;
        const users = data.financingUsers;

        const roles = (data && data.allAssignableFinancingRoles) || [];
        const organizations = data?.financingOrganizations.organizations || [];
        return (
          <NewPage title={i18next.t('appNavDrawer_users')}>
            <AddNewUser roles={roles} organizations={organizations} />
            <Tabs value={activeTabId} onChange={handleTabChange} className={classes.styleTabs}>
              {tabsConfig.map((tab, index) => (
                <Tab key={index} label={tab.label} component={Link} to={`${match.url}${tab.path}`} />
              ))}
            </Tabs>
            <Switch>
              <Redirect exact from={match.url} to={`${match.url}/users`} />
              <Route path={`${match.url}/users`}>
                <UserList users={users} roles={roles} myEmail={myEmail} />
              </Route>
            </Switch>
          </NewPage>
        );
      }}
    </LoadingWrapper>
  );
};
